import {  TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import React, {useEffect, useState} from "react";

import { CheckCircle, Error } from "@mui/icons-material";

const AddFeatureRow = (props) => {
    let [name, setName] = useState()
    let [type, setType] = useState(props.feature.feature_type)

    const updateForm = () => {
        let updatedFeature = Object.assign({}, props.feature)
        updatedFeature.name = name
        updatedFeature.feature_type = type

        props.callback(props.row_num, updatedFeature)
    }

    useEffect(() => {
        updateForm();
    },[name, type])

    let className = props.feature.error ? "add-row row-toast" : "add-row" 
    return (
        <div className={className}>
            <div className="row-error">{props.feature.error}</div>
            <div className="row-form-field">
                <TextField label="Name" variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}} required/>
            </div>

            <div className="row-form-field">
                <Autocomplete
                    disablePortal
                    id="feature-types"
                    width={250}
                    options={props.featureTypes || []}
                    getOptionLabel={option => option.name}
                    defaultValue={props.featureTypes.find(t => t.feature_type === props.feature.feature_type)}
                    style={{ width: "250px" }}
                    renderInput={(params) => <TextField {...params} variant="outlined" size="small" />}
                    onChange={(event, newValue) => {
                        setType(newValue.feature_type) }}
                />
            </div>
            {
                props.feature.success ? <CheckCircle /> : props.feature.error ? <Error /> : null
            }

        </div>
    )
}

export default AddFeatureRow;